var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-dialog',{attrs:{"value":_vm.value},on:{"input":_vm.onInput}},[_c('changelog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }